// components/js/ToolComponent.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';

const ToolComponent = () => {
  const [tools, setTools] = useState([]);

  useEffect(() => {
    axios.get('/api/tools/')
      .then(res => setTools(res.data))
      .catch(err => console.error(err));
  }, []);

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Bioinformatics Tools</h2>
      <table className="w-full table-auto border">
        <thead className="bg-gray-100">
          <tr>
            <th className="p-2">Name</th>
            <th className="p-2">Description</th>
            <th className="p-2">Command</th>
          </tr>
        </thead>
        <tbody>
          {tools.map(tool => (
            <tr key={tool.tool_id} className="border-t">
              <td className="p-2">{tool.name}</td>
              <td className="p-2">{tool.description}</td>
              <td className="p-2">{tool.command_line}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ToolComponent;
